var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1412 475L1412 503",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1412.5,
    cy: 470.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.1 479C1408.64 479 1408.24 478.834 1407.9 478.501C1407.57 478.168 1407.4 477.768 1407.4 477.3C1407.4 476.833 1407.57 476.432 1407.9 476.099C1408.24 475.766 1408.64 475.6 1409.1 475.6C1409.57 475.6 1409.97 475.766 1410.31 476.099C1410.64 476.432 1410.81 476.833 1410.81 477.3C1410.81 477.768 1410.64 478.168 1410.31 478.501C1409.97 478.834 1409.57 479 1409.1 479ZM1417.61 479C1417.14 479 1416.74 478.834 1416.41 478.501C1416.08 478.168 1415.91 477.768 1415.91 477.3C1415.91 476.833 1416.08 476.432 1416.41 476.099C1416.74 475.766 1417.14 475.6 1417.61 475.6C1418.08 475.6 1418.48 475.766 1418.81 476.099C1419.15 476.432 1419.31 476.833 1419.31 477.3C1419.31 477.768 1419.15 478.168 1418.81 478.501C1418.48 478.834 1418.08 479 1417.61 479ZM1408.38 465.4L1410.42 469.65H1416.38L1418.72 465.4H1408.38ZM1407.57 463.7H1420.12C1420.45 463.7 1420.7 463.845 1420.87 464.136C1421.04 464.426 1421.04 464.72 1420.89 465.018L1417.87 470.457C1417.71 470.741 1417.5 470.96 1417.24 471.116C1416.98 471.272 1416.69 471.35 1416.38 471.35H1410.04L1409.1 473.05H1419.31V474.75H1409.1C1408.47 474.75 1407.98 474.47 1407.66 473.911C1407.33 473.351 1407.32 472.795 1407.62 472.242L1408.76 470.16L1405.7 463.7H1404V462H1406.77L1407.57 463.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping2);
export default __webpack_public_path__ + "static/media/shopping_2.2cab80ffc2cfd9e5a7ab155ca87f9bda.svg";
export { ForwardRef as ReactComponent };